module.exports = __webpack_public_path__ + "img/preview.70f22874.jpg";